module.exports = __webpack_public_path__ + "img/TZS03334.23fec9c7.jpg";